/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import $ from 'jquery';
import {
  getDesignPlanList,
  submitDesignConcept,
  getFinalDesignList,
  getDetailProjectByOrderNo,
} from '../../services';

import { IsAlert } from '../../atoms/IsAlert';
import moment from 'moment';
import TabFinalDesign from './TabFinalDesign';
import TabDesignPlans from './TabDesignPlans';
import TabInformation from './TabInformation';
import ProjectDetailTypeA from './ProjectDetailTypeA';
import './ProjectDetailCss.css';

const ProjectDetailComponent = ({ project, setIsLoadingData, tsx }) => {
  // Generals
  moment.locale('en');
  const { orderNo, id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [finalDesigns, setFinalDesigns] = useState(null);
  const [totalArea, setTotalArea] = useState(0);
  const [totalCost, setTotalCost] = useState(0);

  // ================ Express Package Scope ==================
  const [designPlanCheckboxes, setDesignPlanCheckboxes] = useState([]);
  const [designPlans, setDesignPlans] = useState([]);
  const [roomTypeExpress, setRoomTypeExpress] = useState([]);

  const getDesignPlans = async () => {
    try {
      const payload = {
        orderNo: orderNo,
        id: parseInt(id),
        designType: null,
      };
      const response = await getDesignPlanList(payload);
      if (response.message === 'Success' && response.meta.total > 0) {
        setDesignPlans(response.data.designConcept);
      }

      delete payload.designType;
      const responseFinal = await getFinalDesignList(payload);
      if (responseFinal.message === 'Success' && responseFinal.meta.total > 0) {
        setFinalDesigns(responseFinal.data.designConcept);
      }
    } catch (error) {
      setDesignPlans(null);
      setFinalDesigns(null);
    }
  };

  const handleAddNewDesign = async () => {
    if (designPlans === null || designPlans.length < 100) {
      navigate(
        `/project/add-design/${project?.projectInformatin?.orderNo}/${id}`
      );
    } else {
      IsAlert.fire({
        title: 'Warning',
        text: 'You already have 100 design concept.',
        icon: 'warning',
      });
    }
  };

  const handleDesignPlanCheckboxes = (checkboxValue) => {
    setDesignPlanCheckboxes(checkboxValue);
  };

  const handleSubmitDesignConcept = async () => {
    try {
      setIsLoadingData(true);

      const payload = {
        orderNo: orderNo,
        onSubmit: true,
        id: designPlanCheckboxes.map(Number),
        designType: 1,
      };

      const response = await submitDesignConcept(payload);

      if (response.message === 'Success') {
        let additionalTextResponse = '';
        try {
          const responseProjectDetail = await getDetailProjectByOrderNo({
            orderNo: orderNo,
          });

          if (responseProjectDetail.message === 'Success') {
            for (const item of responseProjectDetail?.data || []) {
              if (parseInt(item?.id) !== parseInt(id)) {
                try {
                  const payloadDesignCheck = {
                    orderNo: orderNo,
                    id: parseInt(item?.id),
                    designType: null,
                  };
                  const responseDesignCheck = await getDesignPlanList(
                    payloadDesignCheck
                  );
                  if (responseDesignCheck.message === 'Success') {
                    const findSubmittedDesign =
                      response?.data?.designConcept?.find(
                        (dPlan) => dPlan?.onSubmit === true
                      );
                    if (!findSubmittedDesign) {
                      additionalTextResponse =
                        ' You have 1 other room that is mandatory to submit along with this one.';
                    }
                  }
                } catch (error) {
                  console.error('Error checking design plan:', error);
                }
              }
            }
          }
        } catch (error) {
          console.error('Error fetching project details:', error);
        }

        getDesignPlans();
        setDesignPlanCheckboxes([]);

        IsAlert.fire({
          title: 'Success',
          text: `Design concept submitted. ${additionalTextResponse}`,
          icon: 'success',
        });
      }
    } catch (error) {
      IsAlert.fire({
        title: 'Fail',
        text: error?.response?.data?.message || 'An error occurred',
        icon: 'error',
      });
    } finally {
      setIsLoadingData(false);
    }
  };

  const getRoomType = async () => {
    try {
      const payload = {
        orderNo: orderNo,
      };

      const response = await getDetailProjectByOrderNo(payload);

      if (response.message === 'Success' && response.meta.total > 0) {
        let projectResp = response.data;

        const arrayArea = response.data.map((x) => x.m2);
        const arrayCost = response.data.map((x) => x.project_price);

        const sumArea = arrayArea.reduce(
          (accumulator, currentValue) => accumulator + currentValue,
          0
        );

        const sumCost = arrayCost.reduce(
          (accumulator, currentValue) => accumulator + currentValue,
          0
        );
        setTotalArea(sumArea);
        setTotalCost(sumCost);
        setRoomTypeExpress(projectResp);
      }
    } catch (error) {
      throw error;
    }
  };

  // ================= General =======================
  useEffect(() => {
    getRoomType();
    getDesignPlans();

    // Event click class 'image-component'
    // $('.image-component').on('click', function () {
    //     let imgSrc = $(this).find('img').attr('src')
    // });

    // click tab if state exists
    if (location.state && location.state.tab !== undefined) {
      $(location.state.tab).trigger('click');
    }
  }, []);

  if (
    project.status !== 'New Project' ||
    project?.projectInformatin?.status !== 'Cancelled'
  ) {
    if (project && project?.projectInformatin) {
      return (
        <div className="mt-5">
          {/* Panel tab if status !== New Project or !== Cancelled */}
          {project?.projectInformatin?.status !== 'New Project' &&
            project?.projectInformatin?.status !== 'Cancelled' &&
            project?.projectInformatin?.status !== 'On Setup' && (
              <div className="w-100 pb-3 pb-lg-4 mb-3 mb-lg-4 border-bottom border-lg-0">
                <div className="w-100 swiper-nav swiper">
                  <ul
                    className="nav nav-pills ff2 nav-wrap swiper-wrapper"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li className="nav-item swiper-slide" role="presentation">
                      <button
                        className={`nav-link ${
                          location?.state?.tab === 'designPlan' ||
                          location?.state?.tab === 'finalDesign'
                            ? ''
                            : 'active'
                        }`}
                        id="information-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#information-temp"
                        type="button"
                        role="tab"
                        aria-controls="information"
                        aria-selected="true"
                      >
                        Information
                      </button>
                    </li>
                    <li className="nav-item swiper-slide" role="presentation">
                      <button
                        className={`nav-link ${
                          location?.state?.tab === 'designPlan' ? 'active' : ''
                        }`}
                        id="dplans-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#dplans-temp"
                        type="button"
                        role="tab"
                        aria-controls="dplans"
                        aria-selected="true"
                        disabled={
                          finalDesigns !== null && finalDesigns?.length > 0
                        }
                      >
                        Design Plans
                      </button>
                    </li>
                    <li className="nav-item swiper-slide" role="presentation">
                      <button
                        className={`nav-link ${
                          location?.state?.tab === 'finalDesign' ? 'active' : ''
                        }`}
                        id="fdesign-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#fdesign-temp"
                        type="button"
                        role="tab"
                        aria-controls="fdesign"
                        aria-selected="true"
                        disabled={
                          finalDesigns === null || finalDesigns?.length === 0
                        }
                      >
                        Final Design
                      </button>
                    </li>
                  </ul>
                  <div className="swiper-button-next"></div>
                  <div className="swiper-button-prev"></div>
                </div>
              </div>
            )}
          <div className="tab-content" id="pills-tabContent">
            {/* Information Tab */}
            <TabInformation
              project={project}
              roomTypeExpress={roomTypeExpress}
              tab={location?.state?.tab}
              totalArea={totalArea}
              totalCost={totalCost}
            />

            {/* Design Plans Tab */}
            {project?.projectInformatin?.status !== 'New Project' &&
              project?.projectInformatin?.status !== 'Cancelled' &&
              project?.projectInformatin?.status !== 'On Setup' && (
                <TabDesignPlans
                  designPlans={designPlans}
                  designPlanCheckboxes={designPlanCheckboxes}
                  handleAddNewDesign={handleAddNewDesign}
                  handleDesignPlanCheckboxes={handleDesignPlanCheckboxes}
                  id={id}
                  tab={location?.state?.tab}
                  project={project}
                />
              )}

            {/* Final Design Tab */}
            {project?.projectInformatin?.status !== 'New Project' &&
              project?.projectInformatin?.status !== 'Cancelled' &&
              project?.projectInformatin?.status !== 'On Setup' && (
                <TabFinalDesign
                  id={id}
                  finalDesigns={finalDesigns}
                  project={project}
                  tab={location?.state?.tab}
                />
              )}
          </div>
          <div
            className="modal fade"
            id="modalSubmitDesign"
            tabIndex="-1"
            aria-labelledby="modalSubmitDesignLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content p-3">
                <div className="modal-header border-0">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="w-100 empty-wrap h-unset d-flex align-items-center justify-content-center">
                    <div className="d-grid px-3 px-sm-0">
                      <div className="d-flex align-items-center justify-content-center">
                        <div className="img-wrap img-wrap-empty">
                          <img
                            src="/dist/img/custom/submit-design.svg"
                            alt="item-submit-design"
                          />
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-center mt-4">
                        <div className="fs-4 fw-bold text-center">
                          Submit Design Concept
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-center mt-2 mb-4 text-center">
                        The file that you send in this submission will be
                        received by the customer after all design concepts in
                        each room are submitted
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer border-0 position-relative">
                  <div className="w-50 m-0 p-1">
                    <button
                      type="button"
                      className="btn w-100 btn-line fw-semibold"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="w-50 m-0 p-1">
                    <button
                      type="button"
                      className="btn w-100 m-0 m-sm-1 btn-fill fw-semibold"
                      data-bs-dismiss="modal"
                      onClick={handleSubmitDesignConcept}
                    >
                      Send Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  if (
    project?.status === 'New Project' ||
    project?.projectInformatin?.status === 'Cancelled'
  ) {
    return (
      <ProjectDetailTypeA
        project={
          project.status === 'New Project'
            ? project
            : project.projectInformatin.status === 'Cancelled'
            ? project.projectInformatin
            : null
        }
        roomTypeExpress={roomTypeExpress}
        totalArea={totalArea}
      />
    );
  }
};

export default ProjectDetailComponent;
